const CHANNEL_NAME = 'liceo-auth-sync';

function createChannel() {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return null;
  }
  return new BroadcastChannel(CHANNEL_NAME);
}

export function broadcastAuthLogout() {
  const channel = createChannel();
  if (!channel) {
    return;
  }

  channel.postMessage({ type: 'LOGOUT' });
  channel.close();
}

export function initAuthTabSync(onSessionSynced) {
  const channel = createChannel();
  if (!channel) {
    return () => {};
  }

  channel.onmessage = (event) => {
    if (event.data?.type === 'LOGOUT') {
      onSessionSynced?.({ loggedOut: true });
    }
  };

  return () => channel.close();
}
